const state = {
	returns_form: null
}

const getters = {

}

const actions = {

}

const mutations = {
	setReturnsForm(state, result) {
		state.returns_form = result
	}
}

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations
}
